import React, { useState, useEffect } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, TextField } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import { useTranslation } from 'react-i18next';

const ResetPasswordModal = ({ open, onClose, onSave }) => {
  const { t } = useTranslation();
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (open) {
      setPassword('');
      setError('');
    }
  }, [open]);

  const handleSave = async () => {
    if (!password.trim()) {
      setError(t('password_required'));
      return;
    }

    setLoading(true);
    try {
      await onSave(password);
      setLoading(false);
      onClose();
    } catch (error) {
      setLoading(false);
      console.error('Error resetting password:', error);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle><span className="roboto-regular">{t('reset_password')}</span></DialogTitle>
      <DialogContent>
        <TextField
          margin="normal"
          label={t('new_password')}
          type="password"
          fullWidth
          value={password}
          onChange={(e) => {
            setPassword(e.target.value);
            if (e.target.value.trim()) {
              setError('');
            }
          }}
          error={!!error}
          helperText={error}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('cancel')}</Button>
        <LoadingButton loading={loading} onClick={handleSave} variant="contained" color="primary">
          {t('update')}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default ResetPasswordModal;
